export default __webpack_public_path__ + "static/media/banner-img1.6bf6972f.png";